const googleTtsEndpoint = 'https://texttospeech.googleapis.com/v1/text:synthesize';
const googleApiKey = 'AIzaSyCqKImVIthVaBZbOzoZyqIp2DQfH3cVUSY';
import axios from "axios";

export function getTTSWavFile (text) {
    return new Promise(async resolve => {
        try {
            const response = await axios.post(googleTtsEndpoint, {
                input: {
                    text: text
                },
                voice: {
                    languageCode: 'ko-KR',
                    ssmlGender: 'FEMALE',
                },
                audioConfig: {
                    audioEncoding: 'LINEAR16',
                },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Goog-Api-Key': googleApiKey,
                    'Authorization': googleApiKey,
                },
            });
            // 여기서 response.data는 음성 파일의 바이너리 데이터입니다.
            // 이 데이터를 S3에 업로드하도록 처리해야 합니다.
            let blob = _base64ToBlob(response.data.audioContent, 'wav');
            var file = new File([blob], "tts_file.wav");
            resolve(file)
        } catch (error) {
            console.error('Error generating speech:', error);
            resolve(false);
        }
    })
}

function _base64ToBlob(base64, fileType) {
    let typeHeader = "data:application/" + fileType + ";base64,"; // base64 헤더 파일 유형 정의
    let audioSrc = typeHeader + base64;
    let arr = audioSrc.split(",");
    let array = arr[0].match(/:(.*?);/);
    let mime = (array && array.length > 1 ? array[1] : type) || type;
    // url헤더 제거하고 btye로 변환
    let bytes = window.atob(arr[1]);
    // 예외를 처리하고 0보다 작은 ASCII 코드를 0보다 큰 값으로 변환
    let ab = new ArrayBuffer(bytes.length);
    // 뷰 생성(메모리에 직접): 8비트 부호 없는 정수, 길이 1바이트
    let ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
        type: mime
    });
}
